export default {"src":"__ASTRO_ASSET_IMAGE__CSmIunXs__","width":16,"height":16,"format":"svg"}